// extracted by mini-css-extract-plugin
export default {"img-block":"kuSQA","sticker-candidate":"Dkbaz","img-wrapper":"nqQy9","statistics":"g6QlO","company":"vOrIk","progress":"v8Xr2","wallpaper":"JB5mS"};